/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../Styles';

const SEGMENTED_CONTROL_CONTAINER_STYLE = css`
  label: SEGMENTED_CONTROL_CONTAINER_STYLE;
  display: flex;
  align-items: center;
  height: 30px;
  max-height: 30px;
  gap: ${LAYOUT2.spacing1}px;
`;

const SEGMENTED_CONTROL_LABEL_STYLE = css`
  label: SEGMENTED_CONTROL_LABEL_STYLE;
  ${TYPOGRAPHY2.xSmall}
  color: ${COLORS2.alwaysDark.text.white};
  user-select: none;
`;

const SEGMENTED_CONTROL_BOXES_STYLE = css`
  label: SEGMENTED_CONTROL_BOXES_STYLE;
  display: flex;
  height: 30px;
  max-height: 30px;
  border: 1px solid ${COLORS2.alwaysDark.green};
  border-radius: 0;
`;

const SEGMENTED_CONTROL_BOX_STYLE = css`
  label: SEGMENTED_CONTROL_BOX_STYLE;
  ${TYPOGRAPHY2.xSmall}
  height: 28px;
  max-height: 28px;
  display: flex;
  align-items: center;
  padding: 0 ${LAYOUT2.spacing2}px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
  border: none;
  background: transparent;
  color: ${COLORS2.alwaysDark.green};

  &:not(:last-child) {
    border-right: 1px solid ${COLORS2.alwaysDark.green};
  }
`;

const SEGMENTED_CONTROL_DISABLED_STYLE = css`
  label: SEGMENTED_CONTROL_DISABLED_STYLE;
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
`;

const SEGMENTED_CONTROL_BOX_SELECTED_STYLE = css`
  label: SEGMENTED_CONTROL_BOX_SELECTED_STYLE;
  background: ${COLORS2.alwaysDark.green};
  color: ${COLORS2.alwaysDark.text.black};
`;

export const SegmentedControl = ({
  value,
  options,
  onChange,
  label = 'View By',
  disabled = false,
}: {
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
}) => (
  <div css={[SEGMENTED_CONTROL_CONTAINER_STYLE, disabled && SEGMENTED_CONTROL_DISABLED_STYLE]}>
    {label && <div css={SEGMENTED_CONTROL_LABEL_STYLE}>{label}</div>}
    <div css={SEGMENTED_CONTROL_BOXES_STYLE}>
      {options.map(option => (
        <div
          key={option.value}
          css={[SEGMENTED_CONTROL_BOX_STYLE, value === option.value && SEGMENTED_CONTROL_BOX_SELECTED_STYLE]}
          onClick={() => !disabled && onChange(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  </div>
);
